import React, { useState, useEffect } from "react";
import logo from "assets/images/ebullion-logo.svg";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import { userStore } from "../../store/UserStore";
import { clearSessionData } from "utils";
import TopBands from "./TopBands";
import ArticleView from "pages/articles";
import "./style.css";

interface HeaderProps {
  isLinkShow: boolean;
}

interface NavLinkItem {
  label: string;
  path: string;
  showFor?: "REGISTERED" | "UNREGISTERED" | "ALL";
  isFeature?: boolean;
}

const Header: React.FC<HeaderProps> = ({ isLinkShow }) => {
  const location = useLocation();
  const history = useHistory();
  const [user, customerId, customer] = userStore((state: any) => [
    state.user,
    state.customerId,
    state.customer,
  ]);

  const [isDocShow, setDocShow] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  const signout = () => {
    clearSessionData();
    history.push("/signin");
  };

  const goToExternal = (url: string) => {
    window.open(url, "_blank");
  };

  const isActive = (path: string) => (currentPath === path ? "active" : "");

  const navLinks: NavLinkItem[] = [
    { label: "Dashboard", path: "/dashboard", showFor: "ALL" },
    { label: "Buy/Sell", path: "/buy-sell", showFor: "ALL" },
    { label: "SIP", path: "/sip", showFor: "ALL" },
    { label: "Daily Savings", path: "/daily-saving", showFor: "ALL" },
    { label: "Multimetal SIP", path: "/multimetal-sip", showFor: "UNREGISTERED", isFeature: true },
    { label: "Buy Coins/Bars", path: "/buy-coins-bars", showFor: "UNREGISTERED" },
    { label: "Passbook", path: "/passbook", showFor: "REGISTERED" },
  ];

  const renderNavLinks = () =>
    navLinks
      .filter((link) => {
        if (link.showFor === "ALL") return true;
        return link.showFor === customer?.customerCategory;
      })
      .map((link) => (
        <Nav.Link
          key={link.path}
          className={`${isActive(link.path)} ${link.isFeature ? "feature-highlight" : ""}`}
          as={Link}
          to={link.path}
        >
          {link.label}
        </Nav.Link>
      ));

  return (
    <>
      <TopBands />
      <Navbar bg="white" expand="lg" className="shadow-sm px-5 py-3 sticky-top-nav">
        <Navbar.Brand as={Link} to="/dashboard">
          <img src={logo} alt="Ebullion Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto" variant="tabs">
            {isLinkShow && renderNavLinks()}

            {/* Transactions dropdown for UNREGISTERED */}
            {customer?.customerCategory === "UNREGISTERED" && (
              <NavDropdown
                title="Transactions"
                id="transactions-dropdown"
                className={`custom-dropdown ${isActive("/transactions")}`}
              >
                <NavDropdown.Item as={Link} to="/passbook" className={`custom-dropdown-item ${isActive("/passbook")}`}>
                  Passbook
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/delivery-orders" className={`custom-dropdown-item ${isActive("/delivery-orders")}`}>
                  Delivery Orders
                </NavDropdown.Item>
              </NavDropdown>
            )}

            {/* Charts Dropdown */}
            <NavDropdown title="Charts" id="charts-dropdown" className={`custom-dropdown ${isActive("/charts")}`}>
              <NavDropdown.Item as={Link} to="/price-charts" className={`custom-dropdown-item ${isActive("/price-charts")}`}>
                Price Charts
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/gold-silver" className={`custom-dropdown-item ${isActive("/gold-silver")}`}>
                Gold / Silver Ratio
              </NavDropdown.Item>
            </NavDropdown>

            {/* User Dropdown */}
            <NavDropdown title={user?.displayName || ""} id="user-dropdown" className="me-auto">
              <NavDropdown.Item onClick={() => setDocShow(true)}>Articles</NavDropdown.Item>
              <NavDropdown.Item onClick={() => goToExternal("https://ebullion.in/terms-and-conditions/privacypolicy.html")}>
                Privacy Policy
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => goToExternal("https://ebullion.in/terms-and-conditions/terms.html")}>
                T&C
              </NavDropdown.Item>
              {customerId && <NavDropdown.Divider />}
              {customerId && <NavDropdown.Item onClick={() => history.push("/profile")}>My Profile</NavDropdown.Item>}
              {customerId && <NavDropdown.Divider />}
              <NavDropdown.Item onClick={signout}>Sign Out</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <ArticleView handleModal={() => setDocShow(false)} isShow={isDocShow} />
    </>
  );
};

export default Header;
